/*==================== Header ====================*/

import { headerSearch } from "../../plugins/ComponentsUi/HeaderSearch/HeaderSearch";

/**
 * @param header
 */
const vw = $(window).width();
export const header = {
	scrollActive: function () {
		let height = $("header").height();
		if ($(window).scrollTop() > height) {
			$("header").addClass("active");
		} else {
			$("header").removeClass("active");
		}
	},
	mobile: function () {
		$(".header-hambuger").on("click", function () {
			$(this).toggleClass("active");
			$("body").toggleClass("disable");
			$(".header-menu-tranhphuongnguyen").toggleClass("active");
		});
		// Generate button dropdown for menu
		if (window.matchMedia("(max-width: 1279.98px)").matches) {
			$("li.menu-item-has-children>a").on("click", function (e) {
				let count = $(this).attr("count") || 0;
				if (count > 0) {
					return true;
				} else {
					$(this).toggleClass("active");
					$(this).next("ul").slideToggle();
					$(this).attr("count", count + 1);
					return false;
				}
			});
		}
	},
	init: function () {
		headerSearch();
		header.scrollActive();
		header.mobile();
	},
};
document.addEventListener(
	"scroll",
	function (e) {
		header.scrollActive();
	},
	true
);
